import * as React from "react";
import { Card, CardContent, CardHeader } from '@mui/material';

const Dashboard = () => (
    <Card>
        <CardHeader title="Welcome to Accounts Payable Today" />
        <CardContent>Select from the menu to manage buyers, sellers, invoices, etc.</CardContent>
    </Card>
);

export default Dashboard;